// extracted by mini-css-extract-plugin
module.exports = {"root":"SpinnerView_root__3rZ-n","icon":"SpinnerView_icon__3Rq_U"};